import BaseProxy from '../base-proxy';

/**
 * Class CaSignProxy
 */
class CaSignProxy extends BaseProxy {
  /**
   * Constructor.
   *
   * @param {Object} parameters The query parameters.
   */
  constructor(parameters = {}) {
    super('/e-invoice-api/api/ca-sign', parameters);
    this.defaultOptions = {};
  }

  listHSM() {
    return this.submit('get', `${this.endpoint}/list?is_active=true&ca_type=HSM&no_pagination=true`);
  }

}

export default CaSignProxy;



// WEBPACK FOOTER //
// ./src/store/proxies/e-invoice/ca-sign-proxy.js